module.exports = __webpack_public_path__ + "img/shutterstock2.8f1a671f.jpg";